// third-party
import { createSlice } from '@reduxjs/toolkit';

// project import
import CityDto from 'common/dto-types/city-dto';
import TournamentDto from 'common/dto-types/tournament-dto';
import { PaginationParam, SortingParam, SortingType } from 'components/base-table/dto';
import { DefaultVisibleCityColumns } from 'pages/city-list-page/city-column-config';
import { Filters } from 'react-table';

type CitySliceStates = {
    data?: CityDto;
    isFormOpen: boolean;
    filters: Filters<any>;
    tournamentFilter: TournamentDto | null;
    sorting: SortingParam;
    pagination: PaginationParam;
    visibleColumns: Array<string>;
};

const initialState: CitySliceStates = {
    isFormOpen: false,
    filters: [],
    tournamentFilter: null,
    sorting: { sortingType: SortingType.Ascending, sortBy: 'name', searchTerm: '' },
    pagination: { pageSize: 10, pageIndex: 0 },
    visibleColumns: DefaultVisibleCityColumns,
};

const city = createSlice({
    name: 'city',
    initialState,
    reducers: {
        openCreateForm(state) {
            state.isFormOpen = true;
        },

        closeForm(state) {
            state.data = undefined;
            state.isFormOpen = false;
        },

        setCity(state, action) {
            state.data = action.payload;
        },

        setCityListPersistence(state, action) {
            state.filters = action.payload.filters;
            state.sorting = action.payload.sorting;
            state.pagination = action.payload.pagination;
        },

        setCityListTournamentFilter(state, action) {
            state.tournamentFilter = action.payload;
        },

        setCityColumnsPersistence(state, action) {
            state.visibleColumns = action.payload;
        },
    },
});

export default city.reducer;

export const {
    openCreateForm,
    closeForm,
    setCity,
    setCityListPersistence,
    setCityListTournamentFilter,
    setCityColumnsPersistence,
} = city.actions;
